<div>
  <ng-container *ngFor="let info of infoSnippets">
    <mat-form-field>
      <mat-label>{{info}}</mat-label>
      <textarea matInput [(ngModel)]="data[info]" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" disabled></textarea>
    </mat-form-field>
  </ng-container>
</div>
